import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=1d87fcf6"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"
import style0 from "./Returns.vue?vue&type=style&index=0&id=1d87fcf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports